// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Tabs_tabsContainer__2yTGg","tabsControlsContainer":"Tabs_tabsControlsContainer__37V4x","active":"Tabs_active__2LtYN","icon-text":"Tabs_icon-text__20osC"};